// @flow
import * as React from 'react';

import step1Img from '@images/teasers/HowItworks/Process_Step_1.jpg';
import step2Img from '@images/teasers/HowItworks/Process_Step_2.jpg';
import step3Img from '@images/teasers/HowItworks/Process_Step_3.jpg';
import step4Img from '@images/teasers/HowItworks/Process_Step_4.jpg';

import { HeadlineSection, SubHeadlineSection } from '@components/Headlines';
import { withTranslation } from '@i18n';
import { TeaserList } from '@components';

import type { Props } from './types';

const HowItWorks = ({ t }: Props): React.Node => {
  const images = [step1Img, step2Img, step3Img, step4Img];

  const headlines = [
    t('TeaserHowItWorks.FirstItemTitle'),
    t('TeaserHowItWorks.SecondtItemTitle'),
    t('TeaserHowItWorks.ThirdItemTitle'),
    t('TeaserHowItWorks.FourthItemTitle')
  ];

  const copies = [
    t('TeaserHowItWorks.FirstItemCopy'),
    t('TeaserHowItWorks.SecondtItemCopy'),
    t('TeaserHowItWorks.ThirdItemCopy'),
    t('TeaserHowItWorks.FourthItemCopy')
  ];

  return (
    <TeaserList
      listHeaderComponent={() => (
        <>
          <HeadlineSection>{t('TeaserHowItWorks.Title')}</HeadlineSection>
          <SubHeadlineSection>{t('TeaserHowItWorks.Subtitle')}</SubHeadlineSection>
        </>
      )}
      images={images}
      headlines={headlines}
      copies={copies}
    />
  );
};

export default withTranslation('Hospitals')(HowItWorks);
